// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"80744074","204":"456ceabc","273":"a6e7ba33","661":"51e6ac3b","982":"7dc7c638"}[chunkId] + ".js";
};